import { AllReturns } from "./AllReturns";
import { AllTodaysPickups } from "./AllTodaysPickups";
import { OverDue } from "./OverDue";
import { PendingMaintenance } from "./PendingMaintenance";
import { QuickLinks } from "./QuickLinks";
import { Relocation } from "./Relocation";
import { RepairsIn } from "./RepairsIn";
import { RepairsOut } from "./RepairsOut";
import { UtilizationGraph } from "./UtilizationGraph"

type Props = {
  date: string;
  branchId: number;
  branchTimeZone: string;
};

export const DailyManifest = ({ date, branchId, branchTimeZone }: Props) => {
  return (
    <>
      <div className="w-full flex items-start mt-8 gap-10">
        <UtilizationGraph
          date={date}
          branchId={branchId}
          branchTimeZone={branchTimeZone}
        />

        <QuickLinks />
      </div>

      <div className="w-full mt-4">
        <AllTodaysPickups
          date={date}
          branchId={branchId}
          branchTimeZone={branchTimeZone}
        />
      </div>

      <div className="w-full mt-4">
        <AllReturns
          date={date}
          branchId={branchId}
          branchTimeZone={branchTimeZone}
        />
      </div>

      <div className="w-full mt-4">
        <OverDue
          date={date}
          branchId={branchId}
          branchTimeZone={branchTimeZone}
        />
      </div>

      <div className="w-full mt-4">
        <RepairsIn
          date={date}
          branchId={branchId}
          branchTimeZone={branchTimeZone}
        />
      </div>

      <div className="w-full mt-4">
        <RepairsOut
          date={date}
          branchId={branchId}
          branchTimeZone={branchTimeZone}
        />
      </div>

      <div className="w-full mt-4">
        <PendingMaintenance
          date={date}
          branchId={branchId}
          branchTimeZone={branchTimeZone}
        />
      </div>

      <div className="w-full mt-4">
        <Relocation
          date={date}
          branchId={branchId}
          branchTimeZone={branchTimeZone}
        />
      </div>
    </>
  )
}